module.exports = __webpack_public_path__ + "static/media/gw.813d8932.svg";